import { render, staticRenderFns } from "./CarrinhoEmpresaAgrupamentoTotais.vue?vue&type=template&id=4755aafa"
import script from "./CarrinhoEmpresaAgrupamentoTotais.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresaAgrupamentoTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports